import {Input, Component} from "@angular/core";
import {Subject} from "rxjs";
import {WebmateEvent} from "../../types/base-types";
import {IResourceSummaryComponent} from "./resource-summary.component";

@Component({
  selector: 'wm-generic-resource-summary',
  template: `<div>GENERIC RESOURCE SUMMARY: Project {{projectId}}, Name {{name}}, Description {{description}}, ResourceId {{resourceId}}</div>`
})
export class GenericResourceSummaryComponent implements IResourceSummaryComponent {
  genericEvent: Subject<WebmateEvent>;
  resourceType: string;
  viewType: string;
  @Input() projectId: string;
  @Input() name: string;
  @Input() description: string;
  @Input() logoUrl: string;
  @Input() resourceId: string;
  @Input() params: any;
}
